import { render, staticRenderFns } from "./pageTab.vue?vue&type=template&id=bd53be78&scoped=true"
import script from "./pageTab.vue?vue&type=script&lang=js"
export * from "./pageTab.vue?vue&type=script&lang=js"
import style0 from "./pageTab.vue?vue&type=style&index=0&id=bd53be78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd53be78",
  null
  
)

export default component.exports